// - - - - - - - - - -
// crewVisibility — which crews the grid shows (#703, Leland 2026-10-16; #704 2026-11-02).
//
// Applied once to the crew list every screen reads (modelCx.context.js), in both backend modes:
//   1. A record with NO payroll number is never shown. It can't be assigned a job (a job's
//      installer IS a payroll number), and it rendered as a "0000000" crew that is OFF
//      every day — OCO's delivery drivers.
//   2. The user's crew boxes (Users.defaultFilters.crewFilters + crewSurfaceFilters) — the
//      rules live in jobFilters.js. Until #704 only the Delivery box was applied; the other
//      crew boxes were display-only since the Realm context was retired.
// - - - - - - - - - -
import { FILTERS_CREW_ARRAY } from "./keys";
import { normalizeFilterArray, isCrewShownByFilters } from "./jobFilters";

/** A saved crewFilters array at the current length: missing entries → shown (true). */
export function normalizeCrewFilters(crewFilters) {
  return normalizeFilterArray(crewFilters, FILTERS_CREW_ARRAY);
}

export function isNoPayrollCrew(candidate) {
  return !String(candidate?.payrollNo ?? "").trim();
}

/** RecordType holds one or more types (Recruiter separates them with returns). */
export function isDeliveryOnlyCrew(candidate) {
  const types = String(candidate?.RecordType ?? "")
    .split(/[\r\n,]+/)
    .map((t) => t.trim().toLowerCase())
    .filter(Boolean);
  return types.length > 0 && types.every((t) => t === "delivery");
}

/**
 * The crews the grid shows for this user's crew boxes. Same array back when nothing is hidden.
 * `filters` is the whole currentFilters object; a bare crewFilters array (the #703 call shape)
 * is still accepted.
 */
export function visibleCrews(candidates, filters) {
  if (!Array.isArray(candidates)) return candidates;
  const f = Array.isArray(filters) ? { crewFilters: filters } : filters;
  const out = candidates.filter((c) => !isNoPayrollCrew(c) && isCrewShownByFilters(c, f));
  return out.length === candidates.length ? candidates : out;
}
